import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseNabidkySmlouvySearch } from '@/lib/list-search';

const VykupDetail = lazy(() =>
  import('@/modules/ojeta-vozidla/VykupDetail').then((m) => ({ default: m.VykupDetail })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/vykup/$id',
  component: () => (
    <Suspense fallback={null}>
      <VykupDetail />
    </Suspense>
  ),
  validateSearch: parseNabidkySmlouvySearch,
});
